$(document).ready(function () {
    $(".disp").each(function () {
        counter = 0;
        $(this).click(function () {
            counter++;
            $(this).addClass('active');
            if (counter % 2 == 0) {
                $(this).html("<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/chilly.png' height='90px' width='90px'>");
                $(this).attr("value", "X");
                if ($(this).attr("value") == "O") {
                    $(this).attr("value", "O");
                    $(this).addClass('active');
                }
            }
            else {
                $(this).html("<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/lemon.png' height='75px' width='75px'>");
                $(this).attr("value", "O")
                if ($(this).attr("value") == "X") {
                    $(this).attr("value", "X");
                    $(this).addClass('active');
                }
                $(this).addClass('active');
            }

            var disp_0 = $(".disp:eq(0)").attr("value");
            var disp_1 = $(".disp:eq(1)").attr("value");
            var disp_2 = $(".disp:eq(2)").attr("value");

            var disp_3 = $(".disp:eq(3)").attr("value");
            var disp_4 = $(".disp:eq(4)").attr("value");
            var disp_5 = $(".disp:eq(5)").attr("value");

            var disp_6 = $(".disp:eq(6)").attr("value");
            var disp_7 = $(".disp:eq(7)").attr("value");
            var disp_8 = $(".disp:eq(8)").attr("value");

            var res;
            // Main logic
            if (disp_0 == disp_3 && disp_0 == disp_6) {
                res = disp_0;
            } else if (disp_1 == disp_4 && disp_1 == disp_7) {
                res = disp_1;
            } else if (disp_2 == disp_5 && disp_2 == disp_8) {
                res = disp_2;
            } else if (disp_0 == disp_1 && disp_0 == disp_2) {
                res = disp_0;
            } else if (disp_3 == disp_4 && disp_3 == disp_5) {
                res = disp_3;
            } else if (disp_6 == disp_7 && disp_6 == disp_8) {
                res = disp_6;
            } else if (disp_0 == disp_4 && disp_0 == disp_8) {
                res = disp_0;
            } else if (disp_2 == disp_4 && disp_2 == disp_6) {
                res = disp_2;
            } else {
                res = "NONE";
            }

            if (res == "O") {
                var img_str = "<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/lemon.png' height='90px' width='90px'>";
            } else {
                var img_str = "<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/chilly.png.png' height='90px' width='90px'>";
            }

            if (res == "X" || res == "O") {
                $(".winner-msg").html("<span class='msg'> Winner...<br>" + img_str + " </span><br><img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/victory.gif' height='200px' width='270px' backgroundRepeat = 'no-repeat'></span>");
                $("#js-overlay-trigger").click();
                // game over logic
                if ($(".winner-msg").attr("style") == undefined) {
                    setTimeout(function () {
                        $(".merdge").click(function () {
                            location.reload();
                        });
                    }, 500);
                }
            } else if (counter >= 9) {
                $(".winner-msg").html("<span class='msg'><p>----Its DROW----</p></span>" + "<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/lemon.png' height='75px' width='75px'>" + "<img src='//cdn.shopify.com/s/files/1/0260/4924/9377/t/9/assets/chilly.png' height='75px' width='75px'>");
                $("#js-overlay-trigger").click();
                if ($(".winner-msg").attr("style") == undefined) {
                    setTimeout(function () {
                        $(".merdge").click(function () {
                            location.reload();
                        });
                    }, 500);
                }
            }
        });
    });

    $(".btn").click(function () {
        location.reload();
    });
});